import { render, staticRenderFns } from "./MoleculeImageSlider.vue?vue&type=template&id=45ef387f&"
import script from "./MoleculeImageSlider.vue?vue&type=script&lang=js&"
export * from "./MoleculeImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeImageSlider.vue?vue&type=style&index=0&id=45ef387f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonSliderAtomImageSlider: require('/app/components/atoms/common/slider/AtomImageSlider.vue').default,AtomsCommonSliderAtomVideoSlider: require('/app/components/atoms/common/slider/AtomVideoSlider.vue').default})
